import { X } from "lucide-react";
import type { FC } from "react";

import { cn } from "@/lib/utils";

type Props = {
  label: string;
  /** Shown always on the active tab, on hover elsewhere. */
  active: boolean;
  onClick: () => void;
};

/**
 * The close control shared by the editor and agent-panel tab strips. It is a
 * fixed square that never shrinks, so the "x" is the same size on every tab
 * however far the title is truncated.
 */
export const TabCloseButton: FC<Props> = ({ label, active, onClick }) => (
  <button
    type="button"
    aria-label={label}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    className={cn(
      "ml-0.5 inline-flex size-4 shrink-0 items-center justify-center rounded-sm hover:bg-fill-2",
      active ? "opacity-70" : "opacity-0 group-hover:opacity-70"
    )}
  >
    <X className="size-3 shrink-0" />
  </button>
);
